import { createSlice } from '@reduxjs/toolkit';

import {
	IAddMessages,
	IPromptBuilderParams,
	IPromptProps,
	IPromptTypeOptions,
} from 'features/Settings/PromptBuilder/api/type-def';
import { initialPrompt } from 'features/Settings/PromptBuilder/PromptBuilderDetails/PromptBuilderConstants';

import type { PayloadAction } from '@reduxjs/toolkit';

interface IPromptState {
	promptModalOpen: boolean;
	isPromptEdit: boolean;
	existingPromptDetails: IPromptProps;
	aiModelOptions: IPromptTypeOptions[];
	detailPaneIndex: number;
	prompt: IPromptProps;
	messages: IAddMessages[] | [];
	systemText: string;
	reloadTableData: boolean;
	selectedPrompt: IPromptBuilderParams | null;
}

const initialState: IPromptState = {
	promptModalOpen: false,
	isPromptEdit: false,
	existingPromptDetails: initialPrompt,
	aiModelOptions: [],
	detailPaneIndex: 0,
	prompt: initialPrompt,
	messages: [],
	systemText: '',
	reloadTableData: false,
	selectedPrompt: null,
};

export const promptBuilderSlice = createSlice({
	name: 'promptBuilder',
	initialState,
	reducers: {
		setIsPromptModalOpen: (state, action: PayloadAction<boolean>) => {
			state.promptModalOpen = action.payload;
		},
		setIsPromptEdit: (state, action: PayloadAction<boolean>) => {
			state.isPromptEdit = action.payload;
		},
		setExistingPromptDetails: (state, action: PayloadAction<any>) => {
			state.existingPromptDetails = action.payload;
		},
		setAIModelPromptOptions: (state, action: PayloadAction<any>) => {
			state.aiModelOptions = action.payload;
		},
		setDetailPaneTabIndex: (state, action: PayloadAction<number>) => {
			state.detailPaneIndex = action.payload;
		},
		setMessages: (state, action: PayloadAction<IAddMessages[]>) => {
			state.messages = action.payload;
		},
		setPrompt: (state, action: PayloadAction<IPromptProps>) => {
			state.prompt = action.payload;
		},
		setSystemText: (state, action: PayloadAction<string>) => {
			state.systemText = action.payload;
		},
		setIsReloadTableData: (state, action: PayloadAction<boolean>) => {
			state.reloadTableData = action.payload;
		},
		setSelectedPrompt: (state, action: PayloadAction<IPromptBuilderParams>) => {
			state.selectedPrompt = action.payload;
		},
	},
});

export const {
	setIsPromptModalOpen,
	setIsPromptEdit,
	setExistingPromptDetails,
	setAIModelPromptOptions,
	setDetailPaneTabIndex,
	setPrompt,
	setMessages,
	setSystemText,
	setIsReloadTableData,
	setSelectedPrompt,
} = promptBuilderSlice.actions;
export default promptBuilderSlice.reducer;
